import { render, staticRenderFns } from "./InputTextQuestion.vue?vue&type=template&id=a91a2be8"
import script from "./InputTextQuestion.vue?vue&type=script&lang=js"
export * from "./InputTextQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports